// MisCharge.jsx
import { useState, useMemo, useCallback, useEffect } from "react";
import { Box, Divider } from "@mui/material";
import FieldsTable from "@/Components/Tables/FieldsTable";
export default function TotalValue({ onClose }) {
  const [rows, setRows] = useState([]);
  // FIXED MASTER LIST (MEMOIZED)
  // --------------------------------------------
  const CHARGE_MASTER = useMemo(
    () => [
      "Total Assessable Value Total Basic Duty",
      "Total CVD",
      "Total Excise Education Cess",
      "Total Excise Secondary and Higher Education Cess",
      "Total Custom Education Cess",
      "Total Custom Secondary and Higher Education Cess",
      "Total Additional Duty",
      "Total SWS Duty",
      "Total IGST",
      "Total Duty",
    ],
    []
  );
  const DEFAULT_AMOUNTS = [
    "4500549.19 INR",
    "900109.83 INR",
    "0.0INR",
    "0.0INR",
    "0.0INR",
    "0.0INR",
    "0.0INR",
    "0.0INR",
    "90010.99INR",
    "274533.5INR",
  ];
  // --------------------------------------------
  // INITIAL 14 STATIC ROWS (NO USEEFFECT)
  // --------------------------------------------
  const staticRows = useMemo(() => {
    return CHARGE_MASTER.map((label, i) => ({
      id: i + 1,
      editable: true,
      charges: { type: ["display"], value: [label] },
      amount: {
        type: ["display"],
        value: [DEFAULT_AMOUNTS[i] ?? 0], // ✅ DEFAULT VALUE SET HERE
        disabled: [true],
        dataType: "float",
        editable: false,
      },
    }));
  }, [CHARGE_MASTER]);



  useEffect(() => {
    setRows(staticRows);
  }, [staticRows]);
  // --------------------------------------------
  // COLUMN SCHEMA
  // --------------------------------------------
  const columnFields = useMemo(
    () => [
      { key: "charges", label: "Charges", width: "300px" },
      { key: "amount", label: "Amount", width: "120px" },
    ],
    []
  );
  // --------------------------------------------
  // UI
  // --------------------------------------------
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--gray-0)",
        width: "100%",
        // height: 780,
      }}
    >
      <Divider />

      {/* Table */}
      <FieldsTable
        height={700}
        rowData={rows}
        columnFields={columnFields}
      />
    </Box>
  );
}
